"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const forms_constants_1 = require("@Const/forms-constants");
const react_1 = __importDefault(require("react"));
const AddressSection = (props) => {
    const { userInfo, countryTitle } = props;
    return (react_1.default.createElement("section", { className: 'address-section' },
        react_1.default.createElement("h5", null, "Address"),
        react_1.default.createElement("div", { className: 'fields-row-container' },
            react_1.default.createElement("div", { className: 'field-block' },
                react_1.default.createElement("p", { className: 'small title' }, forms_constants_1.USER_FORM.streetAddress.label),
                react_1.default.createElement("p", { className: 'value' }, userInfo.streetAddress)),
            react_1.default.createElement("div", { className: 'field-block' },
                react_1.default.createElement("p", { className: 'small title' }, forms_constants_1.USER_FORM.unitNumber.label),
                react_1.default.createElement("p", { className: 'value' }, userInfo.unitNumber)),
            react_1.default.createElement("div", { className: 'field-block' },
                react_1.default.createElement("p", { className: 'small title' }, forms_constants_1.USER_FORM.city.label),
                react_1.default.createElement("p", { className: 'value' }, userInfo.city)),
            react_1.default.createElement("div", { className: 'field-block' },
                react_1.default.createElement("p", { className: 'small title' }, forms_constants_1.USER_FORM.state.label),
                react_1.default.createElement("p", { className: 'value' }, userInfo.state)),
            react_1.default.createElement("div", { className: 'field-block' },
                react_1.default.createElement("p", { className: 'small title' }, forms_constants_1.USER_FORM.country.label),
                react_1.default.createElement("p", { className: 'value' }, countryTitle)),
            react_1.default.createElement("div", { className: 'field-block' },
                react_1.default.createElement("p", { className: 'small title' }, forms_constants_1.USER_FORM.postalCode.label),
                react_1.default.createElement("p", { className: 'value' }, userInfo.postalCode)))));
};
exports.default = AddressSection;
